import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useShipTypes } from '../../hooks';
import type { ShipType, ShipTypeFilters } from '../../models';

export interface ShipTypeFieldProps extends Omit<SelectProps<ShipType>, 'options'> {
  defaultFilters?: Partial<ShipTypeFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<ShipType>['errorMessage'];
  isInvalid?: boolean;
}

export const ShipTypeField: React.FC<ShipTypeFieldProps> = ({ defaultFilters, label, ...otherFieldProps }) => {
  const { data, isLoading, updateFilters } = useShipTypes(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
      isLoading={isLoading}
    />
  );
};
